//react
import React, { Component } from 'react';

//colors
import Grid from '@mui/material/Grid';

//siblings
import { setConfig } from '../../core';
import EventsForm from './EventsForm';
import { Box } from '@mui/material';

const s:any ={};

class EventsBase extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  
  render() {
    const { classes, theme, configuration, ...others } = this.props;
    const {user}  = this.props;
    const uploadconfig = Object.assign({}, configuration());
    const config = setConfig(uploadconfig); //
    return (
      <Box sx={{...s.root}}>
        <Grid container spacing={{xs:1,sm:3}}>
          <Grid size={{xs:12,sm:6}}>
            <EventsForm
              action={'upload'}
              record={{}}
              data={[]}
              user={user || ''}
              config={config}
              {...others}
            />
          </Grid>
        </Grid>
      </Box>
    );
  }
}
 
export default EventsBase;
